export default {
  NAME: 'vest-frontend',
  WALLET_CONNECT_PROJECT_ID: '1a65d8e86c5954eae3897a2bd8cdbe30',
};
